var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContinue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.5l7.784-5.833c.45-.334.45-1 0-1.334L15 10.5c-.55-.417-1.333-.017-1.333.667v11.666c0 .684.783 1.084 1.333.667zM17 .333C7.8.333.333 7.8.333 17 .333 26.2 7.8 33.667 17 33.667c9.2 0 16.667-7.467 16.667-16.667C33.667 7.8 26.2.333 17 .333zm0 30C9.65 30.333 3.667 24.35 3.667 17 3.667 9.65 9.65 3.667 17 3.667c7.35 0 13.334 5.983 13.334 13.333 0 7.35-5.984 13.333-13.334 13.333z",
    fill: "#fff"
  })));
}
export default SvgContinue;